(function (window) {
  if (!window || window.BumpJackpotTicker) {
    return;
  }

  function normalizeTickerText(text) {
    return String(text || "").replace(/\u00a0/g, " ").trim();
  }

  function parseMoneyValue(text) {
    var digits = normalizeTickerText(text).match(/\d+/g);
    if (!digits) {
      return 0;
    }

    return Number.parseInt(digits.join(""), 10);
  }

  function extractTickerPattern(targetText) {
    var rawText = String(targetText || "").trim();
    var parts = rawText.match(/^(.*?)(\d(?:[\d\s\u00A0,.'’]*\d)?)(.*?)$/);

    if (!parts) {
      return {
        prefix: "",
        suffix: "",
        groupSeparator: ",",
      };
    }

    var numericPortion = parts[2];
    var separatorMatches = numericPortion.match(/[\s\u00A0,.'’]/g) || [];

    return {
      prefix: parts[1],
      suffix: parts[3],
      groupSeparator: separatorMatches[0] || ",",
    };
  }

  function formatGroupedInteger(value, separator) {
    var roundedValue = Math.max(0, Math.round(value));
    var digits = String(roundedValue);

    if (!separator) {
      return digits;
    }

    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  }

  function formatTickerValue(targetText, value) {
    var pattern = extractTickerPattern(targetText);
    var groupedDigits = formatGroupedInteger(value, pattern.groupSeparator);
    return "" + pattern.prefix + groupedDigits + pattern.suffix;
  }

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }

  function animateValue(element, nextText, options) {
    if (!element) {
      return;
    }

    var settings = options || {};
    var rawTargetText = String(nextText || "").trim();
    var normalizedTargetText = normalizeTickerText(rawTargetText);

    if (!rawTargetText.length) {
      return;
    }

    var targetValue = parseMoneyValue(normalizedTargetText);
    var reducedMotion =
      typeof settings.reducedMotion === "boolean" ? settings.reducedMotion : prefersReducedMotion();
    var threshold = Number.isFinite(settings.threshold) ? settings.threshold : 0;
    var duration = Number.isFinite(settings.duration) ? settings.duration : 2000;

    if (!targetValue || reducedMotion || targetValue < threshold) {
      element.textContent = rawTargetText;
      return;
    }

    var initialValue = Number.isFinite(settings.startValue)
      ? settings.startValue
      : parseMoneyValue(normalizeTickerText(element.textContent));

    if (!settings.force && normalizeTickerText(element.textContent) === normalizedTargetText) {
      return;
    }

    if (element.__bumpTickerFrame) {
      window.cancelAnimationFrame(element.__bumpTickerFrame);
    }

    try {
      element.textContent = formatTickerValue(rawTargetText, initialValue);
    } catch (error) {
      element.textContent = rawTargetText;
    }

    function restoreTargetText() {
      element.textContent = rawTargetText;
      delete element.__bumpTickerFrame;
    }

    var startTimestamp = null;

    function step(timestamp) {
      if (startTimestamp === null) {
        startTimestamp = timestamp;
      }

      var progress = Math.min((timestamp - startTimestamp) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var currentValue = initialValue + (targetValue - initialValue) * eased;

      if (progress >= 1) {
        restoreTargetText();
        return;
      }

      try {
        element.textContent = formatTickerValue(rawTargetText, currentValue);
      } catch (error) {
        restoreTargetText();
        return;
      }

      element.__bumpTickerFrame = window.requestAnimationFrame(step);
    }

    try {
      element.__bumpTickerFrame = window.requestAnimationFrame(step);
    } catch (error) {
      restoreTargetText();
    }
  }

  window.BumpJackpotTicker = {
    animateValue: animateValue,
    normalizeText: normalizeTickerText,
    parseMoneyValue: parseMoneyValue,
  };
})(window);